import { cn } from '@/shared/lib/cn'

/**
 * Motivo decorativo del manual: arcos concéntricos finos, como la estela del
 * isotipo, que sangran por una esquina. Puramente ornamental — `aria-hidden`.
 *
 * Se usa en superficies amplias y tranquilas (hero del login, estados vacíos,
 * páginas de error), nunca detrás de texto denso.
 */
interface BrandArcsProps {
  /** Esquina de origen de los arcos. */
  corner?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  className?: string
}

const ROTATION: Record<NonNullable<BrandArcsProps['corner']>, number> = {
  'top-left': 180,
  'top-right': 270,
  'bottom-right': 0,
  'bottom-left': 90,
}

export function BrandArcs({ corner = 'bottom-right', className }: BrandArcsProps) {
  return (
    <svg
      viewBox="0 0 200 200"
      aria-hidden="true"
      className={cn('pointer-events-none select-none', className)}
      style={{ transform: `rotate(${ROTATION[corner]}deg)` }}
    >
      {[54, 78, 102, 126, 150].map((r, i) => (
        <path
          key={r}
          d={`M200 ${200 - r} A ${r} ${r} 0 0 1 ${200 - r} 200`}
          fill="none"
          stroke="currentColor"
          strokeWidth={i % 2 === 0 ? 3 : 1.5}
          strokeLinecap="round"
        />
      ))}
    </svg>
  )
}
